<template>
  <el-dialog
    title="色・サイズ選択"
    width="60%"
    :visible.sync="dialogVisible"
    @closed="$emit('update:dialogVisible', false)"
  >
    <el-tabs type="card">
      <el-tab-pane label="色設定">
        <color-config :colorSelects="colorSelects"
                      @change="$emit('changeColorSelects', $event)">
        </color-config>
      </el-tab-pane>
      <el-tab-pane label="サイズ設定">
        <size-config :sizeDetails="sizeDetails"
                     :sizeReferences="sizeReferences"
                     :sizeVariation="sizeVariation"
                     :sizeSelects="sizeSelects"
                     @changeVariation="$emit('changeVariation', $event)"
                     @changeSizeUnit="$emit('changeSizeUnit', $event)"
                     @change="$emit('changeSizeSelect', $event)">
        </size-config>
      </el-tab-pane>
      <el-tab-pane label="色サイズ補足情報">
        <input-text
          multiline
          :rows="20"
          :cols="50"
          v-model="colorSizeSupplimental"
          @change="$emit('changeSupplimental', $event)"
          :limitLength="lenColorSizeSup">
        </input-text>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ColorConfig from '@/components/ColorConfig.vue'
import SizeConfig from '@/components/SizeConfig.vue'
import InputText from './InputText.vue'

export default {
  name: 'ColorSizeDialog',
  components: {
    ColorConfig,
    SizeConfig,
    InputText
  },
  props: {
    colorSelects: {
      type: Array
    },
    dialogVisible: {
      type: Boolean
    },
    colorSizeSupplimental: {
      type: String
    },
    sizeVariation: {
      type: String,
      default: '0'
    },
    sizeReferences: {
      type: Array
    },
    sizeDetails: {
      type: Array
    },
    sizeSelects: {
      type: Array
    },
    lenColorSizeSup: {
      type: Number
    }
  }
}
</script>
